<template>
		<div class="home-page">
		<Header></Header>
      <div class="mission-content ac crfff">
        <div class="" @click="back" style="margin-top:40px;width: 80px;height:80px;text-align: center;display: flex;align-items: center;justify-content: center;">
          <img width="50" src="../../static/images/back.png" />
        </div>
        <div class="fs50 mt50">{{$t('word_video')}}</div>
        <div class="css-1asaykn mt50">
          <div class="css-1asaykn mt20">
            <img width="450" src="../../static/images/word_video.gif" />
          </div>
          <div class="css-12nj5ib mt30">
            <div style="">{{$t('word_video_tip')}}</div>
          </div>
          <div class="css-1gzwcwv">
            <div class="custom-input">
              <textarea :placeholder="$t('word_video_input')" v-model="description"></textarea>
            </div>
          </div>
          <div class="css-1gzwcwv">
            <div class="custom-input">
              <input
                type="text"
                :placeholder="$t('generatePromptsTips1')"
                v-model="negativePrompt"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="ac mt30">
          <button style="width: calc(100% - 100px);" @click="creatImage" class="button"><strong>{{$t('Generate')}}</strong></button>
      </div>
<!--      <div class="flex mt50" style="justify-content: space-around;width: 90%;margin: 0 auto;">-->
<!--        <button class="btn btn-blue">{{$t('ChancesLeft')}}: {{score}}</button>-->
<!--        <button class="button" @click="goPurchaseChances" style="padding:8px 10px;width: auto;font-size: 24px;"><strong>{{$t('BuyChances')}}</strong><img style="margin-left: 10px;" width="30" src="../../static/images/buy.png"></button>-->
<!--      </div>-->
      <Dialog ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
          <div class="alert-modal" slot="mdBox" >
              <div class="close" @click="closeTmgDialog" style="text-align: right;margin: 0 auto;font-size: 50px;">×</div>
              <div class="image ac" v-if="imageShow">
                <div class="" style="font-size:28px;margin-bottom: 20px;">{{$t('downTips1')}}</div>
               <img v-if="isShowResult==1" :src="detail.url" style="width:80%;" />
               <img v-if="isShowResult==2" :src="detail.original_url" style="width:80%;" />

               <div class="tab mt20">
                  <span @click="getResult(1)" :class="{'active':isShowResult==1}">{{$t('Result')}}</span>
                  <span @click="getResult(2)" :class="{'active':isShowResult==2}">{{$t('Original')}}</span>
               </div>
                <div class="img-tools">
                  <div class="ac disflex mt30">
                   <div class="input-item">
                     <div class="input-item2" v-if="isShowResult==1">
                       <input class="input" disabled v-model="detail.url"  type="" placeholder="">
                       <img id="copycode" :data-clipboard-text="detail.url" @click="copy" v-if="detail.url" style="margin-left: 10px;" width="90" src="../../static/images/Copy.png" />
                     </div>
                     <div class="input-item2" v-if="isShowResult==2">
                       <input class="input" disabled v-model="detail.original_url"  type="" placeholder="">
                       <img id="copycode" :data-clipboard-text="detail.original_url" @click="copy" v-if="detail.original_url" style="margin-left: 10px;" width="90" src="../../static/images/Copy.png" />
                     </div>
                   </div>
                  </div>
                </div>
              </div>
          </div>
      </Dialog>


      <Dialog ref="processDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
        <div class="alert-modal ac" slot="mdBox" >
          <div class="close" @click="closeProcessDialog" style="text-align: right;margin:10px auto;font-size: 50px;    margin-right: -20px;">
            <img width="70" src="../../static/images/close.png" />
          </div>
          <div class="fs33 mt50 ac">{{processMsg}}</div>
          <button class="button mt30" @click="closeProcessDialog">{{$t('OK')}}</button>
        </div>
      </Dialog>

		</div>
</template>
<script>
import Header from '../components/Header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {

    return {
			detail:{},
			isShow:false,
			value:50,
			imageShow:false,
			imageBase64: null,
			imageTpye:'',
			withScratch:false,
			isImgModel:false,
			isImage:true,
      score:0,
      isShowResult:1,
      processMsg:"",
      description:'',
      negativePrompt:'',
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
	},
    methods: {
      getResult(type){
        this.isShowResult = type
      },
    copy(item){
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
      back(){
        this.$router.go(-1);
      },
		getHome(){
			let that =this;
			that.$api.get('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
          that.score=r.data.score
        });
			})
		},
      creatImage() {
        var that = this;
        if (!that.description) {
          that.$utils.alertText(that.$t('generateImageTips1'),50);
          return;
        }
        let data = {}
        data = {
          description:that.description,
          negativePrompt:that.negativePrompt
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/index/word_to_video',data,r =>{
          that.$parent.loadModal(false);
          that.getHome()
          if(r.code==0){
            that.description = ''
            that.negativePrompt = ''
            that.$refs.processDialog.showMaskFun();
            that.processMsg = r.msg
            return;
          }
          that.$parent.returnCode(r,function(){
            that.$refs.imgDialog.showMaskFun();
            that.imageShow = true
            that.description = ''
            that.negativePrompt = ''
            that.detail = r.data
          });
        })
      },
    getImage(){
       const link = document.createElement('a')
       link.style.display = 'none'
       link.href = this.detail.url
       console.log(link.href)
       // link.target = '_blank'
       link.setAttribute('download', '文件名称')
       document.body.appendChild(link)
       link.click()
        window.open(this.detail.url, '_blank')

    },
    closeTmgDialog(){
      this.detail = {}
      this.$refs.imgDialog.closeMask();
    },
    closeProcessDialog(){
      this.processMsg = ""
      this.$refs.processDialog.closeMask();
    },
    goPurchaseChances(){
      this.$router.push({path:'/purchaseChances'})
    }
	}
}
</script>
<style>
  input.iosSwitch {
      position: relative;
      -webkit-appearance: none;
      -moz-appearance: none;
      outline: none;
      width: 80px;
      height: 40px;
      background-color: #fff;
      border: 1px solid #d9dadc;
      border-radius: 50px;
      box-shadow: inset -20px 0 0 0 #fff;
      margin-right: 15px;
  }

  input.iosSwitch:after {
      content: "";
      position: absolute;
      top: 1px;
      left: 1px;
      background: 0 0;
      width: 46px;
      height: 36px;
      border-radius: 50%;
      box-shadow: 2px 4px 6px rgba(0,0,0,.2);
  }

  input.iosSwitch:checked {
      box-shadow: inset 20px 0 0 0 #0062ff;
      border-color: #0062ff
  }

  input.iosSwitch:checked:after {
      left: 20px;
      box-shadow: -2px 4px 3px rgba(0,0,0,.05);
  }
  .imageInputBox{padding: 90px 20px;min-height: 30px;}
  #activeFormBox input.file,#controlBox input.file {
    width: 100%;
    min-height:300px;
    opacity: 0;
    overflow: hidden;
    z-index: 10;
    position: absolute;
    left: 0;
    top: 0px;
    bottom: 0;
}
.oneImageInput{background: #020e5bb8;border-radius: 14px;box-shadow: 0 0 20px #49c1ff;border: 2px solid #fff;}
.oneImageInput-content{position: relative;min-height: 300px;}
  .withScratchBox{box-shadow: 0 0 20px #49c1ff;padding:40px;border-top: 2px solid #fff;}
  .uploadIcon .label{color:#5562af;margin-top: 20px;}
</style>



// WEBPACK FOOTER //
// src/page/wordToVideo.vue